// /api/v1/estimate
import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const addEstimate = async (bussinessUuid, data) => {
  // const { bussinessUuid } = data;
  try {
    let resp = await http.post(`${URL}/estimate/${bussinessUuid}/create`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

// export const getExpenses = async () => {
//   try {
//     let resp = await http.get(URL + "/expense/get-expenses");
//     return resp;
//   } catch (error) {
//     errorHandler(error);
//   }
// };
// export const addSalaryExpenses = async () => {
//   try {
//     let resp = await http.post(`${URL}/expense/add-salary`);
//     return resp;
//   } catch (error) {
//     errorHandler(error);
//   }
// };

// export const updateExpenses = async (expenseID, data) => {
//   try {
//     let resp = await http.put(`${URL}/expense/${expenseID}`, data);
//     return resp;
//   } catch (error) {
//     errorHandler(error);
//   }
// };

// export const deleteExpenses = async (expenseID) => {
//   try {
//     let resp = await http.delete(`${URL}/expense/${expenseID}`);
//     return resp;
//   } catch (error) {
//     errorHandler(error);
//   }
// };
